/* unplugin-vue-components disabled */import script from "./Dialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./Dialog.vue?vue&type=script&lang=ts&setup=true"

import "./Dialog.vue?vue&type=style&index=0&id=37b795b4&lang=scss"

const __exports__ = script;

export default __exports__